import * as React from 'react';
import {Button, Col, FormControl, HelpBlock} from 'react-bootstrap';
import FaSpinner from 'react-icons/fa/spinner';
import FaSearch from 'react-icons/fa/search';
import {WrappedFieldProps} from 'redux-form';
import {IPostcodeAddress, IPostcodeLookup} from '../../data/api/models';
import * as api from '../../data/api/api';
import FaInfoCircle = require('react-icons/lib/fa/info-circle');

interface IAddressLookUpControlProps extends WrappedFieldProps {
  className: string;

  [option: string]: any;

  onSelectAddress(address: IPostcodeAddress): void;
}

interface IAddressLookUpControlState {
  isSearching: boolean;
  addresses: IPostcodeLookup[];
  postcodeBtnPressed: boolean;
}

const List = ({items, selectAddress}) => {
  const selectAdd = (item) => (e) => {
    selectAddress(item);
  };
  return (
    <>
      {items.map((item: any, i) => (
        <li key={i} onClick={selectAdd(item)}>
          {item.label}
        </li>
      ))}
    </>
  );
};

class AddressLookUp extends React.Component<IAddressLookUpControlProps, IAddressLookUpControlState> {
  public state = {
    isSearching: false,
    addresses: [],
    postcodeBtnPressed: false,
  };

  private searchPostcode = () => {
    const {input} = this.props;

    this.setState({isSearching: true, postcodeBtnPressed: true});

    api.lookupPostcode(input.value)
      .then((addresses) => {
        this.setState({
          isSearching: false,
          addresses,
        });
      });
  }

  private selectAddress = (item) => {
    const {onSelectAddress} = this.props;

    this.setState({
      isSearching: true,
      addresses: [],
      postcodeBtnPressed: false,
    });

    api.getPostcode(item.value)
      .then((address) => {
        this.setState({
          isSearching: false,
        });

        onSelectAddress(address);
      });
  }

  public render() {
    const {input, className, meta, onSelectAddress, ...props} = this.props;
    const {isSearching, addresses, postcodeBtnPressed} = this.state;

    const list = addresses.length > 0 && addresses.map((address: IPostcodeLookup) => {
      return {
        label: address.line,
        value: address.id,
      };
    });

    return (
      <div className={meta.touched && meta.error ? 'has-error' + className : className}>
        <div>
          <Col sm={6}>
            <FormControl
              type="text"
              placeholder="Postcode"
              className={meta.dirty ? 'dirty-field' : ''}
              {...input}
              {...props}
            />
          </Col>
          <Col sm={6} className="input-group-btn-container">
            <Button
              bsStyle="primary"
              className="btn-postcode"
              type="button"
              disabled={isSearching || !input.value}
              onClick={this.searchPostcode}
            >
              Search
              {
                isSearching ?
                  <FaSpinner className="fa-spin icon-margin-left"/>
                  :
                  <FaSearch className="icon-margin-left"/>
              }
            </Button>
          </Col>
        </div>

        {list.length > 0 && (
          <div>
            <Col sm={12} className="address-lookup">
              <ul>
                <List
                  items={list}
                  selectAddress={this.selectAddress}
                />
              </ul>
            </Col>
          </div>
        )}

        {meta.touched && meta.error && <HelpBlock><FaInfoCircle/>{' '}<strong>{meta.error}</strong></HelpBlock>}
        {this.props.input.value
        && addresses.length === 0
        && postcodeBtnPressed
        && !isSearching
        &&
        <div className={'has-error'}>
          <HelpBlock><FaInfoCircle/>{' '}<strong>We were unable to find your address</strong></HelpBlock>
        </div>
        }
      </div>
    );
  }
}

export default AddressLookUp;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/AddressLookUp/index.tsx